import RatingGroup from "../../Components/Charging/RatingGroup";


export default function RatingGroups(){
    return(
        <RatingGroup />
    )
}